import type { IntakeResponse } from '../../services/api';
import type { EpisodeListItem } from '../../hooks/useCreatePatientForm/types';

/**
 * Value for `exclude_patient_id` on Roger duplicate check: only when this intake *created*
 * that patient; omit when the intake matched an existing patient (so they stay in results).
 */
export function excludePatientIdForRogerDuplicateCheck(
  intake:
    | Pick<IntakeResponse, 'is_new_patient' | 'patient_id'>
    | null
    | undefined
): string | null {
  if (!intake) return null;
  return intake.is_new_patient === true ? (intake.patient_id ?? null) : null;
}

/** Pick latest episode by start_of_care date (most recent first). Used when saving match data and when scheduling in Kinnser. */
export function getLatestActiveEpisode(
  episodes: EpisodeListItem[]
): EpisodeListItem | null {
  if (!episodes.length) return null;
  const sorted = [...episodes].sort((a, b) => {
    const dateA = new Date(a.start_date).getTime();
    const dateB = new Date(b.start_date).getTime();
    return dateB - dateA;
  });
  const filtered = sorted.filter(e => e.active);
  return filtered.length > 0 ? filtered[0] : null;
}

/** Normalize an episode date string to YYYY-MM-DD for API, or undefined if invalid. */
export function toEpisodeDateOnly(
  value: string | null | undefined
): string | undefined {
  if (!value || !value.trim()) return undefined;
  const d = new Date(value.trim());
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString().slice(0, 10);
}
